export const translateUserProfiles: { [key: string]: string } = {
  1: "Super Admin",
  2: "Administrador Estadio",
  3: "Supervisor",
  4: "Vendedor",
  5: "Consulta",
  6: "Supervisor POS",
  7: "Recargador",
  8: "Preparador",
  9: "Almacenista",
  10: "Runner",
};
